const dropdown = function()
{
  let items = document.querySelectorAll('.js--dropdown');

  items.forEach(el => {
    el.querySelector('.dropdown__name').addEventListener('click', open)
  });

  function open(e) {
    e.preventDefault();
    this.parentNode.classList.toggle('dropdown--open');
    window.addEventListener('click', close);
  }


  function close(e) {
    if(e.target.closest('.dropdown')) return;
    closeAll();
    window.removeEventListener('click', close);
  }

  function closeAll() {
    items.forEach(el => {
      el.classList.remove('dropdown--open')
    });
  }
  window.dropdown = {};
  window.dropdown.closeAll = closeAll;
}

export default dropdown();
